import React from 'react'
import PropTypes from 'prop-types'
import { UserItemImage } from 'shared/UI/UserItem'
import { SocialLinks } from 'LiveBoard/components/shared/SellerCard/SocialLinks'

import './style.css.scss'

const BIO_SETTINGS_FIELDS = {
  twitter: 'twitter',
  linkedin: 'linkedin',
  content: 'content',
  email: 'email',
}

const BiographySection = ({author}) => {
  const onEmailClick = (e) => e.stopPropagation()

  const getBioSettingsField = (field) => {
    return author.bio_settings && author.bio_settings[field]
  }

  const socialLinks = {
    [BIO_SETTINGS_FIELDS.twitter]: getBioSettingsField(BIO_SETTINGS_FIELDS.twitter) && author[BIO_SETTINGS_FIELDS.twitter],
    [BIO_SETTINGS_FIELDS.linkedin]: getBioSettingsField(BIO_SETTINGS_FIELDS.linkedin) && author[BIO_SETTINGS_FIELDS.linkedin]
  }

  return (
    <div className='bio-container'>
      <div className='image'>
        <UserItemImage user={author} />
      </div>
      <div className='content'>
        <div className='name'>
          {author.name}
        </div>
        <div className='body'>
          <p>{getBioSettingsField(BIO_SETTINGS_FIELDS.content)}</p>
        </div>
        <div className='cta-area'>
          { getBioSettingsField(BIO_SETTINGS_FIELDS.email) &&
            <a href={`mailto:${author.email}`}
              onClick={onEmailClick} >
              <span className="icon-email-full" />
            </a>
          }
          <SocialLinks data={socialLinks} />
        </div>
      </div>
    </div>
  )
}

BiographySection.propsTypes = {
  author: PropTypes.object.isRequired
}
BiographySection.defaultProps = {
  author: { bio_settings: {} }
}

export default BiographySection